import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  href?: string;
  showPrice?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  href = '#precio',
  showPrice = true
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (showPrice) {
      window.open('https://nextlevelvital.com/cart/47655666483444:1', '_blank');
    } else if (href) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.05,
    boxShadow: '0 0 20px rgba(0, 212, 255, 0.5)'
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`
        relative overflow-hidden group
        bg-gradient-to-r from-cyan-600 to-cyan-400
        text-white font-bold text-base md:text-lg tracking-wide uppercase
        py-3.5 md:py-4 px-6 md:px-8 rounded-full
        shadow-[0_0_15px_rgba(0,212,255,0.3)]
        transition-all duration-300
        border border-cyan-300/30
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-13">
      <span className="relative z-10 flex flex-col items-center justify-center gap-1" data-id="element-14">
        <span className="flex items-center gap-2" data-id="element-15">{children}</span>
        {showPrice && <span className="flex items-center gap-2 text-sm md:text-base tracking-wider" data-id="element-16">
            <span className="line-through text-white/50 font-medium" data-id="element-17">
              $19.00
            </span>
            <span className="font-extrabold" data-id="element-18">$6.39 USD</span>
            <span className="bg-red-500 text-white text-[10px] md:text-xs font-bold px-1.5 py-0.5 rounded-full uppercase" data-id="element-19">
              -66%
            </span>
          </span>}
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-20" />
    </motion.button>;
}